export default function SearchIcon({ color = '#79778E' }) {

  return (

    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1842_2466)">
        <path d="M20.53 19.32L16.8 15.59C17.86 14.26 18.5 12.57 18.5 10.75C18.5 6.48 15.02 3 10.75 3C6.48 3 3 6.48 3 10.75C3 15.02 6.48 18.5 10.75 18.5C12.65 18.5 14.4 17.81 15.76 16.67L19.47 20.38C19.62 20.53 19.81 20.6 20 20.6C20.19 20.6 20.38 20.53 20.53 20.38C20.82 20.09 20.82 19.61 20.53 19.32ZM4.5 10.75C4.5 7.3 7.3 4.5 10.75 4.5C14.2 4.5 17 7.3 17 10.75C17 12.44 16.34 13.96 15.25 15.08L15.24 15.09C15.23 15.1 15.23 15.1 15.23 15.11C14.09 16.28 12.5 17 10.75 17C7.3 17 4.5 14.2 4.5 10.75Z" fill={color} />
      </g>
      <defs>
        <clipPath id="clip0_1842_2466">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>

  )

}